module.exports = __webpack_public_path__ + "img/arrowIndicator.3048daf7.svg";